export default __webpack_public_path__ + "static/media/li_img.68ac41e1.png";